import { Category } from "@repo/apis/browse-category-v1";
import { CategoryPills } from "@/components/category-pills";
import {
  TYPOGRAPHY_HEADING1,
  TYPOGRAPHY_BODY3_SENTENCE,
} from "@/theme/topshop/typography/typography-constants";
import { EnrichedFacet } from "@/utils/facets/enrich-facets";
import classes from "./header.module.css";

type HeaderProps = {
  categoryTitle?: string;
  searchQuery?: string;
  itemCount: number;
  facets: EnrichedFacet[];
  category?: Category | null;
};

export const Header = ({
  categoryTitle,
  searchQuery,
  itemCount,
  category,
}: HeaderProps) => {
  return (
    <section className={classes.header}>
      <div className={classes.titleSection}>
        <div className={classes.titleContent}>
          {categoryTitle ? (
            <h1 className={TYPOGRAPHY_HEADING1}>{categoryTitle}</h1>
          ) : null}
          {searchQuery ? (
            <h1 className={TYPOGRAPHY_HEADING1}>
              results for <strong>"{searchQuery}"</strong>
            </h1>
          ) : null}
          <span
            className={`${TYPOGRAPHY_BODY3_SENTENCE} ${classes.desktopItemCount}`}
          >
            {itemCount} items
          </span>
        </div>

        <CategoryPills category={category} />
      </div>
    </section>
  );
};
